import { t } from 'i18next'

import Loading from '~/components/Loading'
import Panel from '~/components/Panel'
import AdsTable from '~/modules/retailMedia/components/_tables/AdsTable'
import CampaignCategoryTable from '~/modules/retailMedia/components/_tables/CampaignCategoriesTable'
import CampaignKeyWordTable from '~/modules/retailMedia/components/_tables/CampaignKeyWordTable'
import CampaignPlacementsTable from '~/modules/retailMedia/components/_tables/CampaignPlacementsTable'
import ProductsTable from '~/modules/retailMedia/components/_tables/ProductsTable'
import AudiencePanel from '~/modules/retailMedia/components/AudiencePanel'
import Budget from '~/modules/retailMedia/components/Budget'
import DestinationUrls from '~/modules/retailMedia/components/Campaign/DestinationUrls'
import { CampaignInsertionOrderPanel } from '~/modules/retailMedia/components/CampaignInsertionOrderPanel'
import CampaignSubpublishers from '~/modules/retailMedia/components/CampaignSubpublishers'
import DailyHistoryTable from '~/modules/retailMedia/components/DailyHistoryTable'
import { InfoView } from '~/modules/retailMedia/components/InfoView'
import { ReviewBar } from '~/modules/retailMedia/components/ReviewBar'
import ReviewCampaignProducts from '~/modules/retailMedia/components/ReviewCampaignProducts'
import ReviewCampaignTargeting from '~/modules/retailMedia/components/ReviewCampaignTargeting'
import { StatusBar } from '~/modules/retailMedia/components/StatusBar'
import StatusHistory from '~/modules/retailMedia/components/StatusHistory'

import MetricsCampaignView from '../Metrics'
import DetailsSponsoredBrands from '../SponsoredBrandsDetails'

const ViewSponsoredBrandCampaign: React.FC<ViewCampaignProps> = ({
  data,
  loading
}) => {
  const hasProducts = !!data.products?.length
  const hasKeywords =
    data?.targetingType === 'keyword' || !!data.keywords?.length
  const hasCategories =
    data?.targetingType === 'category' || !!data.banners?.categories?.length
  const hasPlacements = !!data.settings?.has_placements
  const hasAudience = !!data.audienceId
  const isSubpublisherReview = !!data.isSubpublisherReview
  const isPendingSubpublisherReview =
    isSubpublisherReview && data.status === 'pending_review'

  return (
    <>
      <ReviewBar
        status={data?.status}
        adType={data?.adType}
        message={
          data?.status_history?.length > 0 ? data?.status_history[0]?.note : ''
        }
      />

      {isSubpublisherReview && !isPendingSubpublisherReview && (
        <DestinationUrls data={data} loading={loading} />
      )}

      {!isSubpublisherReview && <MetricsCampaignView />}

      <Loading status={loading}>Carregando dados das campanhas...</Loading>

      {!isSubpublisherReview && <AdsTable campaignAdType={data.adType} />}

      {isSubpublisherReview ? (
        <>
          <hr />
          <ReviewCampaignTargeting data={data} />
          <hr />
          <ReviewCampaignProducts products={data.products} />
        </>
      ) : (
        <>
          {hasProducts && (
            <>
              <hr />
              <Panel
                template="shoreline"
                title={t('rm:relatedProducts')}
                isCollapsible
                noPaddingBody
              >
                <ProductsTable
                  campaignId={data.id}
                  adType={data.adType}
                  publisherId={data.publisher.id}
                />
              </Panel>
            </>
          )}

          <hr />

          <DailyHistoryTable
            campaignType={data.adType}
            campaignStartDate={data.raw.start_at}
          />

          {hasKeywords && (
            <>
              <hr />
              <CampaignKeyWordTable campaignId={data.id} />
            </>
          )}

          {hasCategories && (
            <>
              <hr />
              <CampaignCategoryTable
                campaignId={data.id}
                publisherId={data.publisher.id}
              />
            </>
          )}

          {hasPlacements && (
            <>
              <hr />
              <CampaignPlacementsTable campaignId={data.id} />
            </>
          )}

          <hr />

          <Budget data={data} loading={loading} />

          <CampaignInsertionOrderPanel
            campaignId={data.id}
            insertionOrders={data.insertionOrders}
          />

          {hasAudience && <AudiencePanel audienceId={data.audienceId} />}

          <DetailsSponsoredBrands data={data} />

          <CampaignSubpublishers
            publisherId={data.publisher.id}
            campaignData={data}
          />

          <InfoView data={data} />

          <StatusBar
            status={data?.status}
            message={
              data?.status_history?.length > 0
                ? data?.status_history[0]?.note
                : ''
            }
          />

          <hr />

          <DestinationUrls data={data} loading={loading} />

          <StatusHistory data={data?.status_history} />
        </>
      )}
    </>
  )
}
export default ViewSponsoredBrandCampaign
